import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';
import {
  DealAcquiredJudgmentResultApi,
  DealAcquiredJudgmentResultApiGetDealAcquiredJudgmentResultRequest,
  GetDealAcquiredJudgmentResult200Response,
} from '@/api/openapi';

export class DealAcquiredJudgmentResultApiService extends ApiService {
  api = new DealAcquiredJudgmentResultApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getDealAcquiredJudgmentResult(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<DealAcquiredJudgmentResultApiGetDealAcquiredJudgmentResultRequest>,
  ): Promise<AxiosResponse<GetDealAcquiredJudgmentResult200Response>> {
    return this.checkResponse<GetDealAcquiredJudgmentResult200Response>(
      this.api.getDealAcquiredJudgmentResult(request, options),
      errorHandlers,
    );
  }
}
